import Vue from "vue";
import Router from "vue-router";
import dayjs from "dayjs";
import routes from "./routes";
import httpnoauth from "./axios/httpnoauth";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const activeMaintenanceWindow = (path) => {
  const maintenanceCleared = store.getters["user/maintenanceCleared"];
  const maintenanceBegin = store.getters["root/maintenanceBegin"];
  const maintenanceEnded = store.getters["root/maintenanceEnded"];
  const now = Date.now();

  if (path === "/maintenance") return false;
  if (now > maintenanceBegin && now < maintenanceEnded && !maintenanceCleared) {
    store.commit("app/loading", false);
    return true;
  }
  return false;
};

// Pre Route Hook -- AUTH Check
router.beforeEach(async (to, from, next) => {
  // Check Maintenance Code
  const maintenanceMode = activeMaintenanceWindow(to.path);

  if (maintenanceMode) return next("/maintenance");
  if (to.matched.some(record => !record.meta.requiresAuth)) return next();

  // const declarations
  const now = dayjs().valueOf();
  const expiry = store.getters["user/expiry"];
  const userid = store.getters["user/userid"];
  const isAuthenticated = store.getters["user/isAuthenticated"];
  const refreshToken = store.getters["user/refreshToken"];
  const verified = store.getters["user/isVerified"];
  const roles = store.getters["user/roles"];

  // Check token expiration
  if (expiry - 300 <= now && refreshToken && userid) {
    // Expired Token
    store.commit("root/loading", true);
    // Refresh Token before going to page
    try {
      const response = await httpnoauth.post("/nrl/api/v1/admin/authorize", {
        refresh_token: refreshToken,
        user_id: userid,
      });

      // Refresh Successful - Login User
      store.commit("user/login", response.data);
      store.commit("root/loading", false);
      return next();
    } catch (e) {
      // Failed Refresh - Logout User
      store.commit("user/logout");
      store.commit("root/loading", false);
      router.go("/login");
    }
  }

  // Check Authentication and not expired token
  if (isAuthenticated && expiry - 300 > now) {
    // Valid Token3
    if (!verified) {
      // Account not verified, verification code
      store.commit("root/loading", true);
      return next("/verify");
    }

    if (!roles) {
      return next("/pending");
    }

    if (roles && roles.length === 0) {
      // Account verified, but no roles
      return next("/pending");
    }

    if (
      roles
      && roles.reduce(
        (acc, current) => (current.type === 5
          || current.type === 6
          || current.type === 50
          || current.type === 99
          || current.type === 105
          ? acc + 1
          : acc),
        0
      ) === 0
    ) {
      store.commit("user/logout");
      store.commit("root/loading", false);
      return router.go("/login");
    }

    // Account Verified
    store.commit("root/loading", false);
    return next();
  }

  // No Data - Redirect to Login
  store.commit("user/logout");
  store.commit("root/loading", false);
  next("/login");
});

router.afterEach((to) => {
  const { path, name, meta } = to;
  window.ga("set", "page", path);
  // disable checkProtocolTask https://developers.google.com/analytics/devguides/collection/analyticsjs/tasks
  window.ga("set", "checkProtocolTask", null);
  window.ga("send", {
    hitType: "pageview",
    page: path,
    title: `NRL Manager - ${meta.displayName || name}`,
  });
});

export default router;
